export default __webpack_public_path__ + "static/breadcrumbs-size-dont-3aa7e8e34a8467dfc42eca47666a0c5d43d861486cb486b7e3b95952b4b35aeb.png";